(function () {
  var modalRoot = document.getElementById('jm-lexikon-modal');
  if (!modalRoot) {
    return;
  }

  var dialog = modalRoot.querySelector('.jm-lexikon-modal__dialog');
  var titleNode = modalRoot.querySelector('[data-lexikon-modal-title]');
  var bodyNode = modalRoot.querySelector('[data-lexikon-modal-body]');
  var linkNode = modalRoot.querySelector('[data-lexikon-modal-link]');
  var closeBtn = modalRoot.querySelector('.jm-lexikon-modal__close');
  var activeTrigger = null;
  var isOpen = false;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(event) {
    var focusable = dialog.querySelectorAll(FOCUSABLE);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;
    var isInside = dialog.contains(active) && Array.prototype.indexOf.call(focusable, active) !== -1;
    if (!isInside) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openModal(trigger) {
    if (isOpen) return;

    var title = trigger.getAttribute('data-lexikon-title') || trigger.textContent || 'Lexikon';
    var shortDescription = trigger.getAttribute('data-lexikon-short') || '';
    var detailUrl = trigger.getAttribute('href') || '#';
    var ctaLabel = trigger.getAttribute('data-lexikon-cta') || modalRoot.getAttribute('data-i18n-cta') || 'Zum Lexikonbeitrag';

    titleNode.textContent = title;
    bodyNode.textContent = shortDescription || modalRoot.getAttribute('data-i18n-no-desc') || 'Keine Kurzbeschreibung verfügbar.';
    linkNode.setAttribute('href', detailUrl);
    linkNode.textContent = ctaLabel;

    modalRoot.hidden = false;
    isOpen = true;
    document.documentElement.classList.add('overflow-hidden');
    activeTrigger = trigger;
    closeBtn.focus();
  }

  function closeModal() {
    if (!isOpen) return;
    modalRoot.hidden = true;
    isOpen = false;
    document.documentElement.classList.remove('overflow-hidden');
    if (activeTrigger && typeof activeTrigger.focus === 'function') {
      activeTrigger.focus();
    }
    activeTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.jm-lexikon-trigger');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    if (isOpen && event.target.closest('[data-lexikon-modal-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!isOpen) return;
    if (event.key === 'Escape') {
      closeModal();
    } else if (event.key === 'Tab') {
      trapFocus(event);
    }
  });

  /* ── Client-side auto-linker for product pages ── */

  /* Whitespace-based word boundary helpers.
     Only match terms that are truly standalone: preceded by whitespace
     (or string start) and followed by whitespace, string end, or
     trailing punctuation before whitespace/end.
     This prevents matching inside email addresses, URLs, or
     hyphenated compound words (e.g. "mod-denim.com"). */
  var NOT_WORD = '(?:^|(?<=\\s))';
  var NOT_WORD_AFTER = '(?=\\s|$|[,;:.!?)\\]](?:\\s|$))';

  /* Feature-test for look-behind (Safari <16.4 lacks it).
     Fall back to whitespace-capturing regex if unsupported. */
  var supportsLookBehind = true;
  try { new RegExp('(?<=x)'); } catch (e) { supportsLookBehind = false; }

  function buildPattern(escapedTerms) {
    var joined = escapedTerms.join('|');
    if (supportsLookBehind) {
      return new RegExp(NOT_WORD + '(' + joined + ')' + NOT_WORD_AFTER, 'gi');
    }
    /* Fallback: leading whitespace becomes part of match[0],
       but the captured group match[1] is the term only. */
    return new RegExp('(?:^|\\s)(' + joined + ')(?=\\s|$|[,;:.!?)\\]](?:\\s|$))', 'gi');
  }

  function autoLinkLexikonTerms() {
    var dataScript = document.getElementById('jm-lexikon-terms-data');
    if (!dataScript) return;

    var terms;
    try {
      terms = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }
    if (!terms || !terms.length) return;

    /* Sort terms by title length descending so longer phrases match first
       (e.g. "Regular Fit" before "Fit") */
    terms.sort(function (a, b) {
      return b.t.length - a.t.length;
    });

    var ctaLabel = modalRoot.getAttribute('data-i18n-cta') || 'Zum Lexikonbeitrag';

    /* Build a single regex matching all term titles (case-insensitive) */
    var escaped = terms.map(function (term) {
      return term.t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    var pattern = buildPattern(escaped);

    /* Map lowercase title → term data for quick lookup */
    var termMap = {};
    terms.forEach(function (term) {
      termMap[term.t.toLowerCase()] = term;
    });

    /* Find all value cells on the product page (both desktop and mobile) */
    var valueCells = document.querySelectorAll('.pdt-mf-value, .pdt-mf-acc-value');

    valueCells.forEach(function (cell) {
      /* Quick pre-check: does the cell text contain any term at all? */
      var textContent = cell.textContent || '';
      pattern.lastIndex = 0;
      if (!pattern.test(textContent)) return;
      pattern.lastIndex = 0;

      /* Process text nodes within the cell */
      var walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT, null, false);
      var textNodes = [];
      var node;
      while ((node = walker.nextNode())) {
        /* Skip text inside existing lexikon trigger links */
        if (node.parentElement && node.parentElement.closest('.jm-lexikon-trigger')) continue;
        textNodes.push(node);
      }

      textNodes.forEach(function (textNode) {
        var text = textNode.nodeValue;
        if (!text || !text.trim()) return;

        pattern.lastIndex = 0;
        var match;
        var fragments = [];
        var lastIndex = 0;

        while ((match = pattern.exec(text)) !== null) {
          var matchedText = match[1]; /* captured group (the actual term) */
          var term = termMap[matchedText.toLowerCase()];
          if (!term) continue;

          /* In fallback mode (no lookbehind), match[0] may include a
             leading whitespace char that is not part of the term.
             Calculate the actual term start position. */
          var leadingChars = match[0].length - match[1].length;
          var termStart = match.index + leadingChars;

          /* Add text before the term (includes any leading whitespace) */
          if (termStart > lastIndex) {
            fragments.push(document.createTextNode(text.substring(lastIndex, termStart)));
          }

          /* Create the lexikon trigger link */
          var link = document.createElement('a');
          link.href = term.u;
          link.className = 'jm-lexikon-trigger';
          link.setAttribute('data-lexikon-handle', term.h);
          link.setAttribute('data-lexikon-title', term.t);
          link.setAttribute('data-lexikon-short', term.s || '');
          link.setAttribute('data-lexikon-cta', ctaLabel);
          link.textContent = matchedText;
          fragments.push(link);

          lastIndex = termStart + match[1].length;
        }

        if (fragments.length === 0) return;

        /* Add remaining text after last match */
        if (lastIndex < text.length) {
          fragments.push(document.createTextNode(text.substring(lastIndex)));
        }

        /* Replace the text node with the fragments */
        var parent = textNode.parentNode;
        fragments.forEach(function (frag) {
          parent.insertBefore(frag, textNode);
        });
        parent.removeChild(textNode);
      });
    });
  }

  /* Script is loaded with defer → DOM is already parsed */
  autoLinkLexikonTerms();
})();
